import { FC } from 'react';
import * as vp from 'vopay';
import AccountingSoftwareLayout from '../AccountingSoftwareLayout/AccountingSoftwareLayout';
import styles from './ConnectionSoftware.module.scss';
import { connectSoftwareImageMap } from './ConnectSoftwareImageMap';
import { useTranslation } from 'react-i18next';

type ConnectSoftwareProps = {
  onConnect: () => void;
};
const { Box, Title, SubTitle, Button } = vp;
const ConnectSoftware: FC<ConnectSoftwareProps> = ({ onConnect }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.AccountingSoftware.Connect' });

  return (
    <AccountingSoftwareLayout
      leftContent={
        <div className={styles.leftContainer}>
          <Box flx="col" base="8" gap="lg">
            <Title title={t('title')} />
            <p className={styles.connectionParagraph}>{t('description')}</p>
            <SubTitle subTitle={t('subTitle')} />
            <p className={styles.connectionParagraph}>{t('subDescription')}</p>
          </Box>
        </div>
      }
      rightContent={
        <div className={styles.rightContainer}>
          <Box base="8" gap="ml" flx="col">
            <Box>{t('stepsTitle')}</Box>
            <Box base="5" gap="md" flx="col">
              <Box base="8" gap="ml" flx="row">
                <img
                  className={styles.img}
                  src={connectSoftwareImageMap.computerCheck.src}
                  alt={connectSoftwareImageMap.computerCheck.alt || ''}
                />
                <Box flx="col" jc="center">
                  <h3 className={[styles.connectionParagraph, styles.bold].join(' ')}>{t('stepOne')}</h3>
                  <p className={styles.connectionParagraph}>{t('stepOneDescription')}</p>
                </Box>
              </Box>
              <Box base="8" gap="ml" flx="row">
                <img
                  className={styles.img}
                  src={connectSoftwareImageMap.computerList.src}
                  alt={connectSoftwareImageMap.computerList.alt || ''}
                />
                <Box flx="col" jc="center">
                  <h3 className={[styles.connectionParagraph, styles.bold].join(' ')}>{t('stepTwo')}</h3>
                  <p className={styles.connectionParagraph}>{t('stepTwoDescription')}</p>
                </Box>
              </Box>
            </Box>
          </Box>
        </div>
      }
      bottomRow={
        <Box flx="row" jc="fe">
          <Button id="connect-accounting-software-btn" height="36px" onClick={onConnect} label={t('connectButton')} />
        </Box>
      }
    />
  );
};
export default ConnectSoftware;
